<template>
	<div class="md:w-1/3 px-6 flex flex-col">
		<Score :percentage="percentage" :inline="true">{{
			uiCopy.expertMatch
		}}</Score>
		<p v-if="featuredExpert.expertise" class="mb-6">
			{{ featuredExpert.expertise }}
		</p>
		<div class="bg-white p-8 mb-20 mt-auto">
			<p class="text-primary-200 font-60 type-600 mb-4 md:mb-6">
				{{ featuredExpert.title }}
			</p>
			<img
				v-if="featuredExpert.image"
				:src="featuredExpert.image"
				class="mb-4"
			/>
			<RequestButton
				:expert="featuredExpert.title"
				:userEmail="userEmail"
				v-on:user-requested="userRequested"
				:class="'text-primary-300 btn-outline w-full'"
				>{{ uiCopy.requestMeeting }}</RequestButton
			>
		</div>
	</div>
</template>

<script>
export default {
	data: function () {
		return {
			featuredExpert: null,
			percentage: null,
		}
	},
	props: {
		result: {
			type: Number,
			required: true,
		},
		questions: {
			type: Array,
			required: true,
		},
		userEmail: {
			type: String,
			required: true,
		},
		uiCopy: {
			type: Object,
			required: true,
		},
	},
	created: function () {
		const match = this.questions.find((el) => el.id === this.result)
		this.featuredExpert = match.featuredExpert
		this.percentage = match.percentage
	},
	methods: {
		userRequested: function (data) {
			this.$emit('user-requested', data)
		},
	},
}
</script>
